"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HaulerWithAapTransportQuery = exports.HaulerSapContactUpdateFromWayste = exports.HaulerWithAapTransportToWaysteUpdate = exports.HaulerWithAapTransportToWayste = exports.HaulerSapContactTransportToWayste = exports.HaulerWithAapDataUpdate = exports.HaulerWithAapTransport = exports.HaulerSapContactUpdate = exports.HaulerSapContactCreate = exports.HaulerSapContactTransport = exports.HaulerContact = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const address_transport_1 = require("../common/address-transport");
const nullable_1 = require("../common/nullable");
const dumpster_size_transport_1 = require("./dumpster-size-transport");
const hours_of_operation_transport_1 = require("./hours-of-operation-transport");
const licenseTransport_1 = require("./licenseTransport");
const yard_transport_1 = require("./yard-transport");
exports.HaulerContact = typebox_1.Type.Object({
    department: typebox_1.Type.Optional(typebox_1.Type.String()),
    email: typebox_1.Type.Optional(typebox_1.Type.String()),
    firstName: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastName: typebox_1.Type.Optional(typebox_1.Type.String()),
    phoneNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    sendBillingEmails: typebox_1.Type.Boolean(),
    sendDispatchEmails: typebox_1.Type.Boolean(),
    sendMarketingEmails: typebox_1.Type.Boolean(),
    sendRFPEmails: typebox_1.Type.Boolean(),
    primaryContact: typebox_1.Type.Boolean(),
});
exports.HaulerSapContactTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    haulerId: typebox_1.Type.String(),
    email: typebox_1.Type.Optional(typebox_1.Type.String()),
    firstName: typebox_1.Type.String(),
    lastName: typebox_1.Type.Optional(typebox_1.Type.String()),
    phoneNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    sendBillingEmails: typebox_1.Type.Boolean(),
    sendDispatchEmails: typebox_1.Type.Boolean(),
    sendMarketingEmails: typebox_1.Type.Boolean(),
    sendRFPEmails: typebox_1.Type.Boolean(),
    primaryContact: typebox_1.Type.Boolean(),
    deletedAt: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String({ format: 'date-time' }))),
    metadata: common_1.MetaData,
});
exports.HaulerSapContactCreate = typebox_1.Type.Omit(exports.HaulerSapContactTransport, ['id', 'metadata', 'deletedAt']);
exports.HaulerSapContactUpdate = typebox_1.Type.Partial(typebox_1.Type.Omit(exports.HaulerSapContactTransport, ['id', 'metadata', 'deletedAt', 'haulerId']));
exports.HaulerWithAapTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    waysteHaulerId: typebox_1.Type.String(),
    active: typebox_1.Type.Boolean(),
    isSourgumPartner: typebox_1.Type.Boolean(),
    contacts: typebox_1.Type.Array(exports.HaulerSapContactTransport),
    licences: typebox_1.Type.Optional(typebox_1.Type.Array(licenseTransport_1.LicenseTransport)),
    name: typebox_1.Type.String(),
    billingAddress: address_transport_1.AddressTransport,
    yardAddress: typebox_1.Type.Optional(address_transport_1.AddressTransport),
    yards: typebox_1.Type.Array(yard_transport_1.YardTransport),
    website: typebox_1.Type.Optional(typebox_1.Type.String()),
    dumpsterSizes: typebox_1.Type.Array(dumpster_size_transport_1.DumpsterSizeTransport),
    defaultRentPeriod: typebox_1.Type.Optional(common_1.Duration),
    waysteRentalPeriod: typebox_1.Type.Optional(common_1.Duration),
    rentExtensionFee: typebox_1.Type.Optional(typebox_1.Type.Number()),
    waysteRentalExtensionFee: typebox_1.Type.Optional(typebox_1.Type.Number()),
    rating: typebox_1.Type.Optional(typebox_1.Type.Number()),
    materials: typebox_1.Type.Array(typebox_1.Type.String()),
    hoursOfOperation: hours_of_operation_transport_1.HoursOfOperationTransport,
    notes: typebox_1.Type.String(),
    defaultPaymentMethod: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    defaultPaymentTerm: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    files: typebox_1.Type.Optional(typebox_1.Type.Array(common_1.S3ItemReference)),
    waysteLite: typebox_1.Type.Boolean(),
    sourgumVendorNumber: typebox_1.Type.Integer(),
    metadata: typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    }),
});
exports.HaulerWithAapDataUpdate = typebox_1.Type.Partial(typebox_1.Type.Omit(exports.HaulerWithAapTransport, ['id', 'contacts']));
exports.HaulerSapContactTransportToWayste = typebox_1.Type.Omit(exports.HaulerSapContactTransport, [
    'notes',
    'metadata',
    'haulerId',
]);
exports.HaulerWithAapTransportToWayste = typebox_1.Type.Intersect([
    typebox_1.Type.Pick(exports.HaulerWithAapTransport, [
        'waysteHaulerId',
        'sourgumVendorNumber',
        'defaultPaymentMethod',
        'defaultPaymentTerm',
        'hoursOfOperation',
    ]),
    typebox_1.Type.Object({
        files: typebox_1.Type.Optional(typebox_1.Type.Array(common_1.PreSignedS3Object)),
        contacts: typebox_1.Type.Array(exports.HaulerSapContactTransportToWayste),
    }),
]);
exports.HaulerWithAapTransportToWaysteUpdate = typebox_1.Type.Intersect([
    typebox_1.Type.Pick(exports.HaulerWithAapTransport, ['hoursOfOperation']),
]);
exports.HaulerSapContactUpdateFromWayste = typebox_1.Type.Partial(typebox_1.Type.Omit(exports.HaulerSapContactTransport, ['id', 'metadata', 'deletedAt', 'haulerId', 'notes']));
exports.HaulerWithAapTransportQuery = typebox_1.Type.Partial(typebox_1.Type.Object({
    haulerID: typebox_1.Type.String(), // Comma separated list of hauler IDs
}));
//# sourceMappingURL=hauler-with-aap-transport.js.map